import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TMenuItem {
  id: number;
  name: string;
  url: string;
  valid: boolean;
  description: string;
  menuItemId: number;
  aplModCode: string;
  rbr: number;
}

export interface IMenuItem extends TMenuItem {
  children: IMenuItem[];
}

const MenuItem = Model(
  (model: TMenuItem): IMenuItem => {
    const _menuItem: TMenuItem = Object.assign({}, model);

    let create = (menuItem: IMenuItem): IMenuItem => {
      let obj = ValidatableObject(menuItem);
      return obj;
    };

    let _children: IMenuItem[] = [];

    let menuItem = {
      get id() {
        return _menuItem.id;
      },
      set id(value) {
        _menuItem.id = value;
      },
      get name() {
        return _menuItem.name;
      },
      set name(value) {
        _menuItem.name = value;
      },
      get url() {
        return _menuItem.url;
      },
      set url(value) {
        _menuItem.url = value;
      },
      get valid() {
        return _menuItem.valid;
      },
      set valid(value) {
        _menuItem.valid = value;
      },
      get description() {
        return _menuItem.description;
      },
      set description(value) {
        _menuItem.description = value;
      },
      get menuItemId() {
        return _menuItem.menuItemId;
      },
      set menuItemId(value) {
        _menuItem.menuItemId = value;
      },
      get aplModCode() {
        return _menuItem.aplModCode;
      },
      set aplModCode(value) {
        _menuItem.aplModCode = value;
      },
      get rbr() {
        return _menuItem.rbr;
      },
      set rbr(value) {
        _menuItem.rbr = value;
      },
      get children() {
        return _children;
      },
      set children(value) {
        value =
          value &&
          value.sort((a, b) => {
            return a.rbr - b.rbr;
          });
        _children = value;
      }
    };

    return create(menuItem);
  }
);

export default MenuItem;
